import MInfiniteDetector from "./MInfiniteDetector";

export default {
    install(Vue, options) {
        this.installComponents(Vue);
    },
    installComponents: function (Vue) {
        const components = {
            MInfiniteDetector,
        };
        for (let key in components) {
            Vue.component(key, components[key]);
        }
    }
}